module.exports = __webpack_public_path__ + "img/5.39117c7c.jpg";